import { NgModule } from '@angular/core';
import { RouterModule, Routes } from '@angular/router';
import { ForecastTemperaturesDropComponent } from './forecast-temperatures-drop.component';

const routes: Routes = [
  {
    path: '',
    component: ForecastTemperaturesDropComponent,
  },
];

@NgModule({
  imports: [RouterModule.forChild(routes)],
  exports: [RouterModule],
})
export class ForecastTemperaturesDropRoutingModule {}
